import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useSettings } from '@/contexts/SettingsContext';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import BottomTabs from './BottomTabs';

const LOGO_ICON = 'https://customer-assets.emergentagent.com/job_buyer-match-26/artifacts/52px3160_zynq_logo_icon_e0dde9b0559f42738516da0422c8a0d0.png';

export default function AppLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user } = useAuth();
  const { settings } = useSettings();

  return (
    <div className="min-h-screen bg-background">
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed(!collapsed)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      {/* Mobile Header */}
      <header className="fixed top-0 left-0 right-0 z-30 h-14 border-b border-border bg-background/95 backdrop-blur-md flex items-center px-4 gap-3 md:hidden">
        <button onClick={() => setMobileOpen(true)} data-testid="mobile-menu-btn" className="text-foreground p-1">
          <Menu className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-2">
          <img src={LOGO_ICON} alt="Zynq" className="w-7 h-7 rounded-md" />
          <span className="font-semibold text-sm tracking-tight">{settings.company_name || 'Zynq'}</span>
        </div>
        <div className="ml-auto">
          {user && (
            <div className="w-7 h-7 rounded-full bg-primary/20 flex items-center justify-center text-[10px] font-semibold text-primary">
              {user.name?.charAt(0)?.toUpperCase()}
            </div>
          )}
        </div>
      </header>

      <main
        className={`transition-all duration-300 min-h-screen pt-14 pb-16 md:pt-0 md:pb-0 ${
          collapsed ? 'md:ml-[68px]' : 'md:ml-[240px]'
        }`}
      >
        <div className="p-4 md:p-6 max-w-[1600px] mx-auto">
          {children}
        </div>
      </main>

      <BottomTabs onMoreClick={() => setMobileOpen(true)} />
    </div>
  );
}
